module.exports = __webpack_public_path__ + "img/4手机.1865882b.png";